import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'; // eslint-disable-line
import { Link } from 'react-router-dom';
import constants from '../../constants';

class AlertBanner extends Component {
    constructor(props) {
        super(props);

        this.hideAlert = this.hideAlert.bind(this);
    }

    hideAlert() {
        this.props.clearAlert(this.props.alertId);
    }

    render() {
        let {
            message,
            dismissable,
            alertClass,
            link,
            clearable,
            clearAction,
            linkText,
        } = this.props;

        const closeIcon = <FontAwesomeIcon icon={['far', 'times']} color={constants.StyleColors.white} />;
        let dismissButton = '';
        if (dismissable) {
            dismissButton = (
                // eslint-disable-next-line
                <a className="close-message" aria-label="Close Alert" onMouseUp={this.hideAlert}>
                    {closeIcon}
                </a>
            );
        }
        if (clearable) {
            dismissButton = (
                // eslint-disable-next-line
                <a className="close-message" onClick={clearAction}>
                    {closeIcon}
                </a>
            );
        }

        const showLink = link && typeof link === 'string' && linkText;
        return (typeof message === 'string' ? (
            <div className={`banner ${alertClass}`}>
                <div className="icon-box">
                    <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color={constants.StyleColors.white} />
                </div>
                <p className="banner-message">
                    {`${message}\xa0`}
                    {showLink ? (<Link to={link}>{linkText}</Link>) : ''}
                </p>
                {dismissButton}
            </div>
        ) : <div />
        );
    }
}

export default AlertBanner;
